import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

const OrdersByStatus = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const statusFilter = searchParams.get('status') || ''; // URL의 ?status=배송중 값을 가져옴

  const [orders, setOrders] = useState([]);
  const [orderItemsMap, setOrderItemsMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrdersByStatus = async () => {
      setLoading(true);
      try {
        // 백엔드 API 호출: /api/orders/status?status=배송중
        const res = await axios.get(`/api/orders/status?status=${statusFilter}`);
        setOrders(res.data.orders);
        setOrderItemsMap(res.data.order_items_map);
      } catch (err) {
        console.error("데이터 로드 실패:", err);
      } finally {
        setLoading(false);
      }
    };

    if (statusFilter) {
      fetchOrdersByStatus();
    }
  }, [statusFilter]);

  // 상태 텍스트 및 클래스 결정 (원본 Jinja2 로직 이식)
  const getStatusInfo = (order) => {
    const deliveryStatus = order.delivery_status;
    const isCancelled = order.status === '주문취소';

    if (isCancelled) return { text: '주문취소', color: '#dc3545' };
    if (deliveryStatus === '배송완료') return { text: '배송완료', color: '#28a745' };
    if (deliveryStatus === '배송중') return { text: '배송중', color: '#17a2b8' };
    if (deliveryStatus === '배송준비중') return { text: '상품준비중', color: '#ffc107' };
    return { text: '결제완료', color: '#00704a' };
  };

  if (loading) return <div className="text-center mt-5">데이터를 불러오는 중...</div>;

  return (
    <div className="container my-2 px-0" style={styles.container}>
      {/* 제목: 상태 필터명 (예: 배송중) */}
      <h4 className="mb-3 mx-2" style={styles.pageTitle}>{statusFilter}</h4>

      {orders.length > 0 ? (
        orders.map((order) => {
          const statusInfo = getStatusInfo(order);
          const items = orderItemsMap[order.id] || [];

          return (
            <div key={order.id} className="order-card" style={styles.orderCard}>
              <div className="order-header" style={styles.orderHeader}>
                <div>
                  <div className="order-number" style={styles.orderNumber}>주문번호: {order.id}</div>
                  <div className="order-info order-date" style={styles.orderDate}>
                    주문일자: {order.order_date}
                  </div>
                </div>
                <div className="delivery-section" style={styles.deliverySection}>
                  <div style={{ ...styles.statusText, color: statusInfo.color }}>
                    {statusInfo.text}
                  </div>
                </div>
              </div>

              <div className="product-list">
                {items.map((item, idx) => (
                  <div key={idx} className="product-item" style={styles.productItem}>
                    <div className="product-thumb" style={styles.productThumb}>
                      <img 
                        src={`/static/${item.image_path}`} 
                        alt="상품 이미지" 
                        style={styles.thumbImg} 
                      />
                    </div>
                    <div className="product-info">
                      <div className="product-name" style={styles.productName}>{item.name}</div>
                      <div className="product-qty" style={styles.productQty}>수량: {item.quantity}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="order-actions" style={styles.orderActions}>
                <Link 
                  to={`/order/detail?order_id=${order.id}`} 
                  className="order-detail-link"
                  style={styles.orderDetailLink}
                >
                  주문상세보기
                </Link>
              </div>
            </div>
          );
        })
      ) : (
        <p className="text-muted text-center my-5">해당 상태의 주문이 없습니다.</p>
      )}
    </div>
  );
};

// 원본 CSS 스타일 이식
const styles = {
  container: { width: '100%', maxWidth: '600px', margin: '0 auto', padding: '0 10px 40px', boxSizing: 'border-box' },
  pageTitle: { marginTop: '20px', fontWeight: 'bold' },
  orderCard: { background: 'white', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', marginBottom: '28px', padding: '20px' },
  orderHeader: { borderBottom: '1px solid #eee', paddingBottom: '12px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  orderNumber: { fontWeight: '700', fontSize: '1.1rem' },
  orderDate: { fontSize: '0.75rem', color: '#888' },
  deliverySection: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end' },
  statusText: { fontWeight: '600', fontSize: '0.9rem' },
  productItem: { display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee', padding: '12px 0' },
  productThumb: { width: '60px', height: '60px', overflow: 'hidden', marginRight: '15px', flexShrink: 0, background: '#eee', border: '0px solid #ddd', borderRadius: '6px' },
  thumbImg: { width: '100%', height: '100%', objectFit: 'cover' },
  productName: { fontWeight: '600', fontSize: '1rem', marginBottom: '4px' },
  productQty: { fontSize: '0.85rem', color: '#888' },
  orderActions: { marginTop: '10px', textAlign: 'right' },
  orderDetailLink: { fontSize: '0.9rem', color: '#212529', textDecoration: 'none', fontWeight: '600' }
};

export default OrdersByStatus;